import { Tooltip, tooltipClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import useIsMobile from 'src/hooks/useIsMobile';
import PasswordInstructions, { PasswordInstructionsProps } from './PasswordChecklistList';

const LightTooltip = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: '16px',
        backgroundColor: '#fff',
        borderRadius: '20px',
        border: '1px solid var(--black-20, rgba(17, 17, 17, 0.2))',
        boxShadow: '0px 12px 17px 2px rgba(0, 0, 0, 0.14)',
        left: '6px',
        fontFamily: "'Source Sans Pro'",
        filter: 'none',
        transform: 'none',
        minWidth: '350px',
        '@media (max-width: 480px)': {
            left: '20px',
            bottom: '45px',
        },
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#fff',
        '@media (min-width: 768px)': {
            left: '-21px !important',
            width: '32px !important',
            height: '44px !important',
            marginLeft: '-1em !important',
            '&::before': {
                border: '1px solid var(--black-20, rgba(17, 17, 17, 0.2))',
                borderRadius: '4px',
            },
        },
    },
});

const PasswordChecklistTooltip: React.FC<React.PropsWithChildren<PasswordInstructionsProps>> = (
    props,
) => {
    const isMobile = useIsMobile();
    const { children, ...restProps } = props;

    return (
        <LightTooltip
            arrow
            placement="right"
            title={<PasswordInstructions {...restProps} />}
            disableFocusListener={isMobile}
            disableHoverListener
            disableTouchListener
        >
            <div>{children}</div>
        </LightTooltip>
    );
};

export default PasswordChecklistTooltip;
